import React, { useCallback, useMemo, useEffect, useState } from "react";
import api from "../services/api";
import { writeStorage, readDataStorage } from "../utils/storage/storage";
import { useProgress } from "../hooks/progress";
import {
  useLocation,
  Route as ReactDOMRouter,
  RouteProps as ReactDOMRouteProps,
} from "react-router-dom";

import MiddleareRoute from "./middleware";
import ListFillData from "./middleware/ListFillData";
import RedirectToPath from "./middleware/redirect";
import getStateAbbreviation from "../components/BasicStepper/HolderSteps/StateAbbreviation";
import version from "../../package.json";

interface IRouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  isPrivateAndPublic?: boolean;
  component: React.ComponentType | any;
}

const Route: React.FC<IRouteProps> = ({
  isPrivate = true,
  isPrivateAndPublic = false,
  component: Component,
  ...rest
}) => {
  const path = MiddleareRoute();
  const { setLoad } = useProgress();

  const whiteList = useMemo(() => [{ pathExclude: "/" }], []);

  const checkVersion = useCallback(async () => {
    setLoad(true);
    try {
      const response = await api.get("/csp/versaoapi/consultar/Onboarding");
      if (response.status === 200) {
        const apiVersion = response.data.versoes?.[0].versao;

        if (apiVersion !== version.version) {
          //window.location.reload();
        }
        const { versionStorage } = readDataStorage("appVersion");

        if (apiVersion !== versionStorage) {
          //window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
    }

    setLoad(false);
  }, [setLoad]);

  const searchWhiteList = useCallback(
    (data: string) => {
      const list = ListFillData();
      const search = whiteList.find(({ pathExclude }) => pathExclude === data);
      if (search) {
        return search.pathExclude;
      }
      const itemExcludedFillData = list.find((value) => value === data);
      if (itemExcludedFillData) {
        return itemExcludedFillData;
      }

      if (data.search("/representative/") === 0) {
        return data;
      }

      if (data.search("/indicate/") === 0) {
        return data;
      }

      if (data.search("/card/") === 0) {
        api
          .get("/csp/usuario/consulta/link/" + data.replace("/card/", ""))
          .then((res) => {
            if (res.data.retorno === "card bloqueado") {
              window.location.href = "/onboarding/block";
              writeStorage({
                key: "block",
                object: {
                  id: data.replace("/card/", ""),
                  situacao: res.data.situacaoFase,
                },
              });
            }
            if (res.status === 200 && res.data.retorno !== "card bloqueado") {
              const stateAbbreviation = getStateAbbreviation(
                res.data["estado"]
              );
              api
                .get("/csp/banco/listar/" + stateAbbreviation)
                .then((response) => {
                  let localBanks = [];
                  const {
                    data: {
                      mensagem: { bancos },
                    },
                  } = response;
                  for (const k in bancos) {
                    const { nomBan } = bancos[k];
                    localBanks.push({ value: bancos[k], label: nomBan });
                  }

                  writeStorage({
                    key: "bancos",
                    object: {
                      bancosStorage: localBanks,
                    },
                  });
                })
                .catch((err) => {
                  setLoad(false);
                  console.error(err);
                });

              writeStorage({
                key: "home",
                object: {
                  estado: res.data["estado"],
                  idCard: res.data["idCard"],
                  pessoa: res.data["tipo"],
                  Concessionaria: res.data["concession_ria"],
                },
              });

              writeStorage({
                key: "card",
                object: {
                  NomeTitularConta: res.data["empresa"],
                  OndeEconomizar: res.data["onde_voc_quer_economizar"],
                  Pessoa: res.data["tipo"],
                  CNPJrepresentante: res.data["cnpj_do_representante_1"],
                  Estado: res.data["estado"],
                  Cidade: res.data["cidade"],
                  Bairro: res.data["bairro"],
                  Rua: res.data["rua"],
                  Numero: res.data["n_mero"],
                  Complemento: res.data["complemento"],
                  Classe: res.data["classe"],
                  Subclasse: res.data["subclasse"],
                  Jan: res.data["jan"],
                  Fev: res.data["fev"],
                  Mar: res.data["mar"],
                  Abr: res.data["abr"],
                  Mai: res.data["mai"],
                  Jun: res.data["jun"],
                  Jul: res.data["jul"],
                  Ago: res.data["ago"],
                  Set: res.data["set"],
                  Out: res.data["out"],
                  Nov: res.data["nov"],
                  Dez: res.data["dez"],
                  MediaConsumo: res.data["m_dia_de_consumo"],
                  FormaPagamento: res.data["forma_de_pagamento"],
                  CEPvalidoCard: 1,
                  RazaoSocialCard: res.data["raz_o_social"],
                  Email: res.data["email"],
                  EmailDoResponsavel: res.data["email_do_respons_vel_legal"],
                  TelefoneTitularConta:
                    res.data["telefone_do_titular_da_conta"],
                  TelefoneResponsavelLegal:
                    res.data["telefone_do_respons_vel_legal"],
                  cpfCnpjCard:
                    res.data["tipo"] === "PJ"
                      ? res.data["cnpj"]
                      : res.data["cpf"],
                  DataNascimentoTitular: res.data[
                    "data_de_nascimento_do_titular"
                  ]
                    ?.split(" ")[0]
                    .split("/")
                    .reverse()
                    .join("-"),
                  NomeResponsavelLegal: res.data["nome_do_respons_vel_legal"],
                  CPF:
                    res.data["tipo"] === "PF"
                      ? res.data["cpf"]
                      : res.data["cpf_do_respons_vel_legal"],
                  CEP: res.data["cep"],
                  NumeroInstalacao: res.data["n_mero_da_instala_o_cemig_1"],
                  DataVencimentoFatura:
                    res.data["data_de_vencimento_da_fatura_cemig"],
                  Banco: res.data["banco"],
                  CodBanco: res.data["codban"],
                  Agencia: res.data["ag_ncia"],
                  Conta: res.data["conta"],
                  OptanteSimples: res.data["empresa_optante_pelo_simples"],
                  Concessionaria: res.data["concession_ria"],
                  arquivos: res.data["fotos"],
                },
              });
              switch (parseInt(res.data["mensalidade_axs"]) > 0) {
                case false:
                  window.location.href = "/onboarding/step/1";
                  break;
                case true:
                  setLoad(true);
                  api
                    .post(`/csp/proposta/gerar/`, {
                      concessionaria: res.data["concession_ria"],
                      subClasse: res.data["subclasse"],
                      estado: res.data["estado"],
                      classe: res.data["classe"],
                      consumo: {
                        jan: res.data["jan"],
                        fev: res.data["fev"],
                        mar: res.data["mar"],
                        abr: res.data["abr"],
                        mai: res.data["mai"],
                        jun: res.data["jun"],
                        jul: res.data["jul"],
                        ago: res.data["ago"],
                        set: res.data["set"],
                        out: res.data["out"],
                        nov: res.data["nov"],
                        dez: res.data["dez"],
                      },
                    })
                    .then((res) => {
                      if (res.status === 200) {
                        writeStorage({
                          key: "consumo",
                          object: {
                            arvoresCultivadas:
                              res.data["mensagem"]["arvoresCultivadas"],
                            carbonoEvitado:
                              res.data["mensagem"]["carbonoEvitado"],
                            economiaVerde:
                              res.data["mensagem"]["economiaVerde"],
                            economiaVerdeAno2:
                              res.data["mensagem"]["economiaVerdeAno2"],
                            economiaVerdeAno3:
                              res.data["mensagem"]["economiaVerdeAno3"],
                            economiaVerdeAno4:
                              res.data["mensagem"]["economiaVerdeAno4"],
                            economiaVerdeAno5:
                              res.data["mensagem"]["economiaVerdeAno5"],
                            economiaAmarela:
                              res.data["mensagem"]["economiaAmarela"],
                            economiaAmarelaAno2:
                              res.data["mensagem"]["economiaAmarelaAno2"],
                            economiaAmarelaAno3:
                              res.data["mensagem"]["economiaAmarelaAno3"],
                            economiaAmarelaAno4:
                              res.data["mensagem"]["economiaAmarelaAno4"],
                            economiaAmarelaAno5:
                              res.data["mensagem"]["economiaAmarelaAno5"],
                            economiaVermelhaI:
                              res.data["mensagem"]["economiaVermelhaI"],
                            economiaVermelhaIAno2:
                              res.data["mensagem"]["economiaVermelhaIAno2"],
                            economiaVermelhaIAno3:
                              res.data["mensagem"]["economiaVermelhaIAno3"],
                            economiaVermelhaIAno4:
                              res.data["mensagem"]["economiaVermelhaIAno4"],
                            economiaVermelhaIAno5:
                              res.data["mensagem"]["economiaVermelhaIAno5"],
                            economiaVermelhaII:
                              res.data["mensagem"]["economiaVermelhaII"],
                            economiaVermelhaIIAno2:
                              res.data["mensagem"]["economiaVermelhaIIAno2"],
                            economiaVermelhaIIAno3:
                              res.data["mensagem"]["economiaVermelhaIIAno3"],
                            economiaVermelhaIIAno4:
                              res.data["mensagem"]["economiaVermelhaIIAno4"],
                            economiaVermelhaIIAno5:
                              res.data["mensagem"]["economiaVermelhaIIAno5"],
                            economiaEscassez:
                              res.data["mensagem"]["economiaEscassez"],
                            economiaEscassezAno2:
                              res.data["mensagem"]["economiaEscassezAno2"],
                            economiaEscassezAno3:
                              res.data["mensagem"]["economiaEscassezAno3"],
                            economiaEscassezAno4:
                              res.data["mensagem"]["economiaEscassezAno4"],
                            economiaEscassezAno5:
                              res.data["mensagem"]["economiaEscassezAno5"],
                            kmCarroEletrico:
                              res.data["mensagem"]["kmCarroEletrico"],
                            graficoConsumoXGeracao:
                              res.data["mensagem"]["graficoConsumoXGeracao"],
                            mensalidade: res.data["mensagem"]["mensalidade"],
                            concessionaria:
                              res.data["mensagem"]["concessionaria"],
                            subClasse: res.data["mensagem"]["subClasse"],
                            classe: res.data["mensagem"]["classe"],
                            consumoMinimo:
                              res.data["mensagem"]["consumoMinimo"],
                            economiaAnual:
                              res.data["mensagem"]["economiaAnual"],
                            mediaFinal: res.data["mensagem"]["mediaFinal"],
                          },
                        });
                        window.location.href = "/onboarding/step/2";
                      }
                    });
                  break;
                default:
                  window.location.href = "/onboarding/";
              }
            }
          });
        return data;
      }
    },
    [whiteList, setLoad]
  );

  const location = useLocation();
  const [hasCheckedVersion, setHasCheckedVersion] = useState(false);

  useEffect(() => {
    writeStorage({
      key: "appVersion",
      object: {
        versionStorage: version.version,
      },
    });
    if (
      !hasCheckedVersion &&
      (location.pathname === "/" ||
        location.pathname === "/representative" ||
        location.pathname === "/indicate" ||
        location.pathname === "/card")
    ) {
      checkVersion();
      setHasCheckedVersion(true);
    }
  }, [hasCheckedVersion, location.pathname, checkVersion]);

  return (
    <ReactDOMRouter
      {...rest}
      render={({ location }) => {
        if (location.pathname === path.pathName) {
          return <Component />;
        }
        return location.pathname === searchWhiteList(location.pathname) ? (
          <Component />
        ) : (
          <RedirectToPath
            path={path.pathName}
            description={path.description}
            message={path.message}
          />
        );
      }}
    />
  );
};

export default Route;
